import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly allowedIframeHosts = new Set([
    'www.youtube.com',
    'youtube.com',
  ]);

  constructor(private sanitizer: DomSanitizer) {
    // Add hook to enforce rel="noopener noreferrer" on target="_blank" links
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
      if (node.tagName === 'A' && node.hasAttribute('target')) {
        node.setAttribute('rel', 'noopener noreferrer');
      }

      if (node.tagName === 'IFRAME') {
        const src = node.getAttribute('src');
        if (!src) {
          node.parentNode?.removeChild(node);
        } else {
          try {
            const parsed = new URL(src);
            if (
              parsed.protocol !== 'https:' ||
              !this.allowedIframeHosts.has(parsed.hostname)
            ) {
              node.parentNode?.removeChild(node);
            }
          } catch {
            node.parentNode?.removeChild(node);
          }
        }
      }
    });
  }

  transform(html: string): SafeHtml {
    if (!html) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const cleaned = DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        'a',
        'b',
        'i',
        'em',
        'strong',
        'p',
        'br',
        'span',
        'div',
        'table',
        'tbody',
        'thead',
        'tr',
        'td',
        'th',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'ul',
        'ol',
        'li',
        'img',
        'iframe',
      ],
      ALLOWED_ATTR: [
        'href',
        'target',
        'rel',
        'class',
        'id',
        'style',
        'colspan',
        'rowspan',
        'src',
        'title',
        'alt',
        'width',
        'height',
        'frameborder',
        'allow',
        'allowfullscreen',
      ],
      ALLOW_DATA_ATTR: false,
    });

    return this.sanitizer.bypassSecurityTrustHtml(cleaned);
  }
}
